import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2c32884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-selected-transaction" }
const _hoisted_2 = { class: "desktop-selected-transaction__heading" }
const _hoisted_3 = { class: "desktop-selected-transaction__list" }
const _hoisted_4 = { class: "desktop-selected-transaction__item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, "نرخ:", -1))
const _hoisted_6 = { class: "desktop-selected-transaction__item-value" }
const _hoisted_7 = {
  key: 0,
  class: "desktop-selected-transaction__item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, "کارمزد شبکه:", -1))
const _hoisted_9 = {
  dir: "ltr",
  class: "desktop-selected-transaction__item-value font-english"
}
const _hoisted_10 = {
  key: 1,
  class: "desktop-selected-transaction__item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " کارمزد حواله بانکی: ", -1))
const _hoisted_12 = { class: "desktop-selected-transaction__item-value" }
const _hoisted_13 = {
  key: 2,
  class: "desktop-selected-transaction__item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " مقدار دریافتی نهایی: ", -1))
const _hoisted_15 = {
  dir: "ltr",
  class: "desktop-selected-transaction__item-value font-english"
}
const _hoisted_16 = {
  key: 3,
  class: "desktop-selected-transaction__item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " مبلغ دریافتی: ", -1))
const _hoisted_18 = { class: "desktop-selected-transaction__item-value" }
const _hoisted_19 = { class: "desktop-selected-transaction__item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, "حساب مقصد:", -1))
const _hoisted_21 = {
  dir: "ltr",
  class: "desktop-selected-transaction__item-value font-english"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 4,
  class: "desktop-selected-transaction__item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " شناسه تراکنش (TXID): ", -1))
const _hoisted_25 = {
  dir: "ltr",
  class: "desktop-selected-transaction__item-value font-english text-primary cursor-pointer",
  style: {"word-break":"break-word"}
}
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0668E1",
  d: "M9.131 17.023H3.145a2.51 2.51 0 0 1-2.507-2.507V6.023a2.51 2.51 0 0 1 2.507-2.507h5.986a2.51 2.51 0 0 1 2.507 2.507v8.493a2.51 2.51 0 0 1-2.507 2.507zM3.145 4.769c-.691 0-1.253.562-1.253 1.254v8.493c0 .691.562 1.253 1.253 1.253h5.986c.691 0 1.253-.562 1.253-1.253V6.023c0-.692-.562-1.254-1.253-1.254H3.145zm11 8.179V3.484A2.51 2.51 0 0 0 11.638.977H4.681a.627.627 0 0 0 0 1.254h6.957c.691 0 1.254.562 1.254 1.253v9.464a.626.626 0 1 0 1.253 0z"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 5,
  class: "desktop-selected-transaction__item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " کد رهگیری حواله: ", -1))
const _hoisted_31 = { class: "desktop-selected-transaction__item-value font-english" }
const _hoisted_32 = { class: "desktop-selected-transaction__item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-selected-transaction__item-title" }, " لینک عمومی رسید: ", -1))
const _hoisted_34 = {
  dir: "ltr",
  class: "desktop-selected-transaction__item-value font-english text-primary cursor-pointer",
  style: {"word-break":"break-word"}
}
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0668E1",
  d: "M9.131 17.023H3.145a2.51 2.51 0 0 1-2.507-2.507V6.023a2.51 2.51 0 0 1 2.507-2.507h5.986a2.51 2.51 0 0 1 2.507 2.507v8.493a2.51 2.51 0 0 1-2.507 2.507zM3.145 4.769c-.691 0-1.253.562-1.253 1.254v8.493c0 .691.562 1.253 1.253 1.253h5.986c.691 0 1.253-.562 1.253-1.253V6.023c0-.692-.562-1.254-1.253-1.254H3.145zm11 8.179V3.484A2.51 2.51 0 0 0 11.638.977H4.681a.627.627 0 0 0 0 1.254h6.957c.691 0 1.254.562 1.254 1.253v9.464a.626.626 0 1 0 1.253 0z"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.copied)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copied = undefined)),
          variant: "primary",
          title: "با موفقیت کپی شد",
          duration: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" جزئیات سفارش " + _toDisplayString(_ctx.selected.type === "buy" ? "خرید" : "فروش") + ": ", 1),
        _createElementVNode("div", {
          class: _normalizeClass([
          'desktop-selected-transaction__status',
          `desktop-selected-transaction__status--${_ctx.selected.status}`,
        ])
        }, _toDisplayString(_ctx.status), 3)
      ]),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(Number(_ctx.selected.rate).toLocaleString()) + " تومان ", 1)
        ]),
        (_ctx.selected.type === 'buy')
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(Number(_ctx.selected.transaction_fee).toLocaleString()) + " USDT ", 1)
            ]))
          : (_ctx.selected.type === 'sell')
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(Number(_ctx.selected.settle_fee).toLocaleString()) + " تومان ", 1)
              ]))
            : _createCommentVNode("", true),
        (_ctx.selected.type === 'buy')
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(Number(_ctx.selected.final).toLocaleString()) + " USDT ", 1)
            ]))
          : (_ctx.selected.type === 'sell')
            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(Number(_ctx.selected.final).toLocaleString()) + " تومان ", 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_ctx.selected.bank_logo && _ctx.selected.type === 'sell')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.selected.bank_logo,
                  alt: "bank",
                  width: "26",
                  height: "26"
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.selected.type === "buy" ? _ctx.selected.address : _ctx.selected.ir_num), 1)
          ])
        ]),
        (_ctx.selected.type === 'buy')
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("a", {
                  href: _ctx.selected.txid_link,
                  target: "_blank"
                }, _toDisplayString(_ctx.selected.txid) + "  ", 9, _hoisted_26),
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.selected.txid))),
                  style: {"transform":"scale(0.8)"},
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "18"
                }, _hoisted_28))
              ])
            ]))
          : (_ctx.selected.type === 'sell')
            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.selected.settle_msg), 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("a", {
              href: _ctx.selected.public_url,
              target: "_blank"
            }, _toDisplayString(_ctx.selected.public_url.split("//")[1]) + "  ", 9, _hoisted_35),
            (_openBlock(), _createElementBlock("svg", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy(_ctx.selected.public_url))),
              style: {"transform":"scale(0.8)"},
              xmlns: "http://www.w3.org/2000/svg",
              width: "15",
              height: "18"
            }, _hoisted_37))
          ])
        ])
      ])
    ])
  ], 64))
}